import { render } from "./YoutubeEmbed.vue?vue&type=template&id=48ca6073"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__